import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ActivityBlock } from '../../abstract/ActivityBlock.js';
export class UiConfirmation {
  constructor() {
    _defineProperty(this, "captionL10nStr", 'confirm-your-action');
    _defineProperty(this, "messageL10Str", 'are-you-sure');
    _defineProperty(this, "confirmL10nStr", 'yes');
    _defineProperty(this, "denyL10nStr", 'no');
  }
  confirmAction() {
    console.log('Confirmed');
  }
  denyAction() {
    this['historyBack']();
  }
}
export class ConfirmationDialog extends ActivityBlock {
  constructor() {
    super(...arguments);
    _defineProperty(this, "activityType", ActivityBlock.activities.CONFIRMATION);
    /** @private */
    _defineProperty(this, "_defaults", new UiConfirmation());
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      activityCaption: '',
      messageTxt: '',
      confirmBtnTxt: '',
      denyBtnTxt: '',
      '*confirmation': null,
      onConfirm: this._defaults.confirmAction,
      onDeny: this._defaults.denyAction.bind(this)
    }));
  }
  initCallback() {
    super.initCallback();
    this.set$({
      messageTxt: this.l10n(this._defaults.messageL10Str),
      confirmBtnTxt: this.l10n(this._defaults.confirmL10nStr),
      denyBtnTxt: this.l10n(this._defaults.denyL10nStr)
    });
    this.sub('*confirmation', (/** @type {UiConfirmation} */cfn) => {
      if (!cfn) {
        return;
      }
      this.set$({
        '*currentActivity': ActivityBlock.activities.CONFIRMATION,
        activityCaption: this.l10n(cfn.captionL10nStr),
        messageTxt: this.l10n(cfn.messageL10Str),
        confirmBtnTxt: this.l10n(cfn.confirmL10nStr),
        denyBtnTxt: this.l10n(cfn.denyL10nStr),
        onDeny: () => {
          cfn.denyAction();
        },
        onConfirm: () => {
          cfn.confirmAction();
        }
      });
    });
  }
}
ConfirmationDialog.template = /* HTML */"\n  <lr-activity-header>\n    <button type=\"button\" class=\"mini-btn\" set=\"onclick: *historyBack\">\n      <lr-icon name=\"back\"></lr-icon>\n    </button>\n    <span>{{activityCaption}}</span>\n    <button type=\"button\" class=\"mini-btn close-btn\" set=\"onclick: *closeModal\">\n      <lr-icon name=\"close\"></lr-icon>\n    </button>\n  </lr-activity-header>\n\n  <div class=\"message\">{{messageTxt}}</div>\n  <div class=\"toolbar\">\n    <button type=\"button\" class=\"deny-btn secondary-btn\" set=\"onclick: onDeny\">{{denyBtnTxt}}</button>\n    <button type=\"button\" class=\"confirm-btn primary-btn\" set=\"onclick: onConfirm\">{{confirmBtnTxt}}</button>\n  </div>\n";